import { useQuery } from 'react-query'
import { get } from 'framework/api/http'

/* Get the distinct, deduplicated ServiceNameDescription ("Process") values across all recipients */
export const getProcessOptions = async () => {
  const res = await get('/NotificationRecipient/ProcessOptions')
  return res.data
}

export const useGetProcessOptions = () => {
  return useQuery(['emailAlertProcessOptions'], getProcessOptions, {
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  })
}

export default useGetProcessOptions
